import assert from '@banking/ui/utils/assert';
import { Uint8ToString } from '@banking/ui/utils/uint8-to-string';
import { SubtextType } from './debit-card-list-item';
export const getBusinessName = cardRenderingDescription => {
  const {
    businessName
  } = cardRenderingDescription;
  return businessName;
};
export const getCustomizationImageDataURL = cardRenderingDescription => {
  const {
    cardCustomization
  } = cardRenderingDescription;
  if (cardCustomization == null) {
    return '';
  }
  const {
    mimeType,
    signatureImageBytes
  } = cardCustomization;
  if (mimeType.length === 0 || signatureImageBytes.length === 0) {
    return '';
  }
  return `data:${mimeType};base64,${Uint8ToString(signatureImageBytes)}`;
};

// TODO(cvu): remove this when owner card is 100% supported by new card management
// We want the seller to be able to navigate old card management for their first owner card
const isFirstOwnerCardFunc = isOwnerCardMap => {
  const firstOwnerCardToken = Object.keys(isOwnerCardMap).find(key => isOwnerCardMap[key]);
  return cardToken => cardToken === firstOwnerCardToken;
};
export const createDebitCardsListItemsFromCards = (cards, isOwnerCardMap, onActivatableCardClick, onCardInvitationClick, onCardClick, onSingleOwnerCardClick, canAccessNewAccountHolderCardSettings) => {
  const isFirstOwnerCard = isFirstOwnerCardFunc(isOwnerCardMap);
  return cards.map(card => {
    const {
      cardInvite,
      orderedCard
    } = card;
    if (cardInvite) {
      const {
        inviteToken,
        cardListElement,
        cardName,
        secondaryText
      } = cardInvite;
      assert(cardListElement != null, 'card list element is null/undefined');
      assert(secondaryText != null, 'secondary text is null/undefined');
      return {
        businessName: getBusinessName(cardListElement),
        cardName,
        customizationImageDataURL: getCustomizationImageDataURL(cardListElement),
        showOwnerCardTooltip: false,
        // card invites are always non-owner cards and there are no card tokens
        subtext: secondaryText.text,
        subtextType: SubtextType.Standard,
        onClick: () => onCardInvitationClick(inviteToken)
      };
    } else if (orderedCard) {
      const {
        cardListElement,
        cardName,
        secondaryText,
        isActivatable,
        cardToken
      } = orderedCard;
      const isOwnerCard = isOwnerCardMap[cardToken];
      const canAccessCardSettings = !isOwnerCard || canAccessNewAccountHolderCardSettings;
      assert(cardListElement != null, 'card list element is null/undefined');
      assert(secondaryText != null, 'secondary text is null/undefined');
      if (isActivatable) {
        return {
          businessName: getBusinessName(cardListElement),
          cardName,
          customizationImageDataURL: getCustomizationImageDataURL(cardListElement),
          showOwnerCardTooltip: !canAccessCardSettings,
          subtext: secondaryText.text,
          subtextType: SubtextType.Action,
          onClick: () => onActivatableCardClick(cardToken)
        };
      }

      // TODO(cvu): remove this when owner card is 100% supported by new card management
      if (!canAccessNewAccountHolderCardSettings && isOwnerCard && isFirstOwnerCard(cardToken)) {
        return {
          businessName: getBusinessName(cardListElement),
          cardName,
          customizationImageDataURL: getCustomizationImageDataURL(cardListElement),
          /*
           * NOTE(cvu): yes I know this is hacky setting this so the tool tip does not show,
           * however, to centralize the clunky, hacky nature of this temporary solution to
           * allow for most cardholders to access their cards in dashboard, this kind of
           * has to be done.
           */
          showOwnerCardTooltip: false,
          subtext: secondaryText.text,
          subtextType: SubtextType.Standard,
          onClick: onSingleOwnerCardClick
        };
      }
      return {
        businessName: getBusinessName(cardListElement),
        cardName,
        customizationImageDataURL: getCustomizationImageDataURL(cardListElement),
        showOwnerCardTooltip: !canAccessCardSettings,
        subtext: secondaryText.text,
        subtextType: SubtextType.Standard,
        onClick: canAccessCardSettings ? () => onCardClick(cardToken) : undefined
      };
    } else {
      throw new Error('Missing cardInvite/orderCard from card');
    }
  });
};